import React from "react";

const Heading = () => {
  return (
    <div className="headerWrapper">
      <header className="App-header">CYF Hotel</header>
      <img
        className="image"
        src="https://image.flaticon.com/icons/svg/139/139899.svg"
        alt="CYF Hotel"
      />
    </div>
  );
};
export default Heading;
